export default __webpack_public_path__ + "static/media/qr.5b32d4e1.svg";